export default function destinationReducer(destination, action) {
  switch (action.type) {
    case "set":
      return action.value;

    case "exten":
      return { ...destination, [action.type]: action.value ? Number(action.value).toString() : "" };
    case "ringSeconds":
      return { ...destination, [action.type]: action.value ? Number(action.value) : null };

    default:
      return { ...destination, [action.type]: action.value };
  }
}
